import Button from 'src/components/atoms/Button/Button'
import {
    StyledDatePicker,
    StyledInput,
} from 'src/components/atoms/Input/Input.style'
import { styled } from 'src/styles/stitches.config'

export const StyledHorizontalBooking = styled('div', {
    backgroundColor: '$green',
    width: 'calc(20 * $colWidth)',
    margin: 'auto',
    marginTop: '0!important',
    paddingLeft: '$colWidth',
    color: '$white',
    transform: 'translateY(-50%)',

    '@lg': {
        height: '15vh',
    },

    [`${StyledInput} input`]: {
        color: '$white',
        borderColor: '$white',
        '&:placeholder': {
            color: 'white',
        },
        '&::-webkit-calendar-picker-indicator': {
            filter: 'invert(1)',
        },
    },
    svg: {
        stroke: '$white!important',
    },
    '.react-date-picker': {
        backgroundColor: '#465346!important',
        padding: '0.25rem $sm',
    },
    '.picker-wrapper': {
        width: '75%',
    },
    [`${StyledDatePicker}`]: {
        paddingLeft: 0,
    },
})

//Erase:
export const DateWrapper = styled('div', {
    width: 'calc(4 * $colWidth)',
})

export const SubmitWrapper = styled('div', {
    width: 'calc(5 * $colWidth)',
    height: '100%',
    [`${Button}`]: {
        width: '100%',
        height: '100%',
    },
})

export const selectStyles = {
    control: (provided: any) => ({
        ...provided,
        backgroundColor: 'var(--colors-green)',
        border: 'none',
        boxShadow: 'none!important',
        height: '50px',
        marginTop: 'var(--space-xs)',
        paddingLeft: '0.5rem',
        paddingRight: '0.5rem',
    }),
    singleValue: (provided: any) => ({
        ...provided,
        color: 'var(--colors-white)',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    option: (provided: any, state: any) => ({
        ...provided,
        color: '#000',
        backgroundColor: state.isSelected
            ? '#ddd'
            : state.isFocused
            ? '#eee'
            : '#fff',
    }),
}
